import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";

import { Condition } from "../types";
import { conditionFormSchema, ConditionVariables } from "../schemas";
import { useCreateConditionMutation, useUpdateConditionMutation } from "../api/mutations";

  interface UseConditionProps {
  condition?: Condition;
  onClose?: () => void;
}

export const useCondition = ({ condition, onClose }: UseConditionProps) => {
  const createConditionMutation = useCreateConditionMutation();
  const updateConditionMutation = useUpdateConditionMutation();

  const form = useForm<ConditionVariables>({
    resolver: zodResolver(conditionFormSchema),
    defaultValues: {
      name: condition?.name ?? "",
      date_diagnosed: condition?.date_diagnosed ?? "",
      is_treated: condition?.is_treated ?? false,
      medication: condition?.medication ?? "",
    },
  });

  const onSubmit = async (data: ConditionVariables) => {
    try {
      if (condition) {
        await updateConditionMutation.mutateAsync({
          id: condition?.condition_id ?? "",
          name: data?.name ,
          date_diagnosed: data?.date_diagnosed ,
          is_treated: data?.is_treated ?? false,
          medication: data?.medication ?? "",
        });
      } else {
        await createConditionMutation.mutateAsync({
          name: data?.name ,
          date_diagnosed: data?.date_diagnosed ,
          is_treated: data?.is_treated ?? false,
          medication: data?.medication ?? "",
        });
      }

      toast.success("Profile updated successfully");
      onClose?.();
    } catch (error) {
      console.error(error);
      toast.error("Failed to update profile");
    }
  };

  return {
    form,
    onSubmit,
    isLoading: createConditionMutation.isPending || updateConditionMutation.isPending,
  };
};
